import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {MatCard, MatCardContent, MatCardSubtitle, MatCardTitle} from '@angular/material/card';
import {Format, FormatPipe} from '@aviary/pipes/format.pipe';
import {RouteName} from '@app/app.route-names.generated';
import {NamedRouterLinkDirective} from '@lib/directives/named-router-link/named-router-link.directive';
import {TruncateDirective} from '@aviary/directives/truncate.directive';
import {hasValue} from '@aviary/store/common/typing.helpers';

@Component({
  selector: 'px-stat-card',
  templateUrl: './stat-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCard, MatCardTitle, MatCardSubtitle, FormatPipe, MatCardContent, NamedRouterLinkDirective, TruncateDirective]
})
export class StatCardComponent {

  @Input({required: true}) public titleValue: string;

  @Input() public subtitleLabel?: string;

  @Input() public set subtitleValue(subtitleValue: string | number | undefined) {
    this._subtitleValue = subtitleValue ?? '';
    this.showSubtitle = hasValue(subtitleValue);
  }

  public get subtitleValue(): string | number {
    return this._subtitleValue;
  }

  @Input() public subtitleValueFormat: Format = 'NUMBER';

  @Input({required: true}) public value: number;
  @Input() public valueFormat: Format = 'NUMBER';

  @Input({required: true}) targetRouteName: RouteName;

  public showSubtitle: boolean = false;

  private _subtitleValue: string | number;
}
